import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from '../utils/apiBase';

export const healthCheckerApi = createApi({
    reducerPath: 'healthCheckerApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getApiBaseUrl() || '/',
    }),
    endpoints: (builder) => ({
        submitHealthCheckerQuiz: builder.mutation({
            query: (quizData) => ({
                url: '/api/healthchecker-quiz/',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: quizData,
            }),
        }),
    }),
});

export const { useSubmitHealthCheckerQuizMutation } = healthCheckerApi;
